import { forwardRef } from 'react';

export interface ForwardRefInputProps extends React.PropsWithoutRef<JSX.IntrinsicElements['input']> {}

const ForwardRefInput = forwardRef<HTMLInputElement, ForwardRefInputProps>(({ children, ...props }, ref) => {
  return (
    <>
      {children}
      <input {...props} ref={ref} />
    </>
  );
});
export default ForwardRefInput;
